import { render, staticRenderFns } from "./ReportBlacklistActivityPDF.vue?vue&type=template&id=53501b4d&scoped=true&"
import script from "./ReportBlacklistActivityPDF.vue?vue&type=script&lang=js&"
export * from "./ReportBlacklistActivityPDF.vue?vue&type=script&lang=js&"
import style0 from "./ReportBlacklistActivityPDF.vue?vue&type=style&index=0&id=53501b4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53501b4d",
  null
  
)

export default component.exports